import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'travel-ui-autosuggest-popup',
  templateUrl: './autosuggest-popup.component.html',
  styleUrls: ['./autosuggest-popup.component.scss']
})
export class AutosuggestPopupComponent implements OnInit {
  @Input()
  set autosuggestOptions(data: any) {
    if (data) {
      this.options = data;
    }
  }

  @Input()
  set preselectedOption(data: string) {
    this.searchStr = data;
  }
  @Output() close = new EventEmitter();
  @Output() optionselected = new EventEmitter();
  @Output() searchString = new EventEmitter();

  options: any[]=[];
  selectedOption = {};
  isOpened = false;
  searchStr = '';
  typeAndIconMapping: any = {
    city: 'fa-building',
    pointOfInterest: 'fa-map-marker',
    hotel: 'fa-hotel',
    airport: 'fa-plane',
    multiCity: 'fa-building'
  };
  constructor() { }

  getClickedOption(option: {}) {
    this.selectedOption = option;
    this.optionselected.emit(option);
  }

  closeAutosuggest() {
    this.close.emit();
  }

  initiateSearch() {
    if (this.searchStr.length > 2) {
      this.searchString.emit({
        searchStr: this.searchStr
      });
    } else {
      this.options = [];
    }
  }

  removeSearchStr() {
    this.searchStr = '';
    this.options = [];
  }

  ngOnInit() { }
}
